<app-header-latest></app-header-latest>
@if (successMessage) {
<div class="col-lg-12">
    <div class="row">
        <div class="col-md-12">
            <div class="error-section">
                <div class="images">
                    <div class="custom-icon">
                        <p class="check-mark ps-5" style="margin: 0px 55px 0px 0;"><i class="fa-solid fa-circle-check"></i></p>
                    </div>
                </div>
                <h3 style="margin: 0px 15px 0px 0px;">Verified</h3>
                <h3>{{statusMessage}}</h3>
            </div>
        </div>
    </div>
</div>
}@else{
<div class="col-lg-12">
    <div class="row">
        <div class="col-md-12">
            

                    <div class="container padding-y-80 d-flex justify-content-center align-items-center min-vh-80">
                        <div class="download-section text-center">
                            <p class="check-mark"><i class="fa-solid fa-circle-check"></i></p>
                            <div class="row">

                                <div class="col-lg-6 offset-lg-3 text-center">

                                    <h3 style="font-size: 1.5rem;"> Already Verified.</h3>

                                    <h3 style="font-size: 1rem;">Please click here to <a
                                            (click)="goTo('/sign-in')"><span class="primary-color"
                                                style="cursor: pointer;">Login.</span></a></h3>

                                </div>
                            </div>


                        </div>
                    </div>
              
        </div>
    </div>
</div>
}
<div class="gray-bg py-0">
    <app-our-apps></app-our-apps>
</div>

<app-footer-more-info></app-footer-more-info>